export const getUsersCount = profiles => {
  return `
        SELECT
            COUNT(Id) 
        FROM 
            User 
        WHERE 
            profile.name IN ( ${profiles} )
            AND profile.name != 'Comercial'
            AND profile.name != null 
            AND UserRole.Name != null
            AND isActive = true
    `;
};
